'use client'

import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {Image} from '@/src/shared/ui/image'

export const Wrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;

  @media ${media.md} {
    margin-top: 70px;
    margin-bottom: 70px;
  }
`

export const ImageList = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 35px;

  @media ${media.md} {
    grid-template-columns: repeat(auto-fill, minmax(147px, 1fr));
    gap: 50px;
  }
`

export const BrandImage = styled(Image)`
  max-height: 92px;
  width: auto;
  height: auto;

  &:hover {
    transition: transform ease 0.3s;
    transform: scale(1.2);
  }
`

export const LettersLinks = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`

export const LettersWrapper = styled.div`
  margin-top: 20px;
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: 10px;

  @media ${media.md} {
    margin-top: 70px;
  }
`

export const Letter = styled.a<{noLink?: boolean}>`
  font-weight: 450;
  cursor: pointer;
  padding: 5px 10px;
  border: solid 1px ${props => (!props.noLink && props.theme.colors.gray6) || 'none'};
  border-radius: 5px;
  text-decoration: unset;
  color: ${theme.colors.dark};
`

export const Container = styled.div`
  align-items: baseline;

  display: grid;
  flex-direction: column;

  grid-template-columns: max-content 1fr;

  gap: 10px;
`

export const Brands = styled.div`
  display: flex;
  flex-wrap: wrap;

  align-items: center;
  column-gap: 100px;
  row-gap: 10px;
`
